import React from "react";
import { ModeRendererProps } from "./types";

export function GrandmaMode({ brand, Copy }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.white} />
      <g transform="translate(397 480)">
        <use href="#shield" fill="none" stroke={brand.black} strokeWidth="12" />
        <path d="M-30 10 L-6 34 L36 -14" fill="none" stroke={brand.green} strokeWidth="14" strokeLinecap="round" />
      </g>
      <text x="46" y="780" fontFamily="sans-serif" fontWeight="800" fontSize="34" fill={brand.black}>
        Suzan AI Cybersecurity Whitepaper
      </text>
      <text x="46" y="820" fontFamily="sans-serif" fontWeight="600" fontSize="20" fill="#333">
        Practical DevSecOps, Simplified
      </text>
      {/* date/version removed */}
    </g>
  );
}
